import { render } from "./rightLine.vue?vue&type=template&id=0964f248"
import script from "./rightLine.vue?vue&type=script&lang=js"
export * from "./rightLine.vue?vue&type=script&lang=js"

import "./rightLine.vue?vue&type=style&index=0&id=0964f248&lang=less"
script.render = render

export default script